
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface ToursErrorProps {
  message?: string;
}

const ToursError: React.FC<ToursErrorProps> = ({ message }) => {
  const { t } = useLanguage();
  
  return (
    <Alert variant="destructive" className="text-center py-6">
      <AlertCircle className="h-5 w-5" />
      <AlertTitle>{t('error')}</AlertTitle>
      <AlertDescription>
        {message || t('error_loading_tours')}
      </AlertDescription>
    </Alert>
  );
};

export default ToursError;
